import { Swiper } from 'swiper/bundle'
import * as factory from '../../../iawp/src/js/factory'
import openMobileSubmenu from '../../../iawp/src/js/modules/openMobileSubmenu'
import {IADropdownFaq, filterFaqs} from './iaDropdownFaq.js'
import openSubmenu from './openSubmenu'
import { initProductFinderSubmissionForm} from './productFinder.js'
import priceRangeSlider from './priceRangeSlider.js'
import IAScrollAnimation from './IAScrollAnimation'
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import '@justinribeiro/lite-tiktok';
import de from 'air-datepicker/locale/de'

import $ from '../../../iawp/node_modules/jquery-validation'

new factory.IAInit()
var mainMenu = document.querySelector('.section-header');
var topMenu = document.querySelector('.section-topbar');
openSubmenu(topMenu)
openSubmenu(mainMenu)

const headerGlob = {offsetHeight : mainMenu.offsetHeight + topMenu.offsetHeight}
new IAScrollAnimation(document.querySelectorAll('[href^="#"]:not([href="#"]):not([href="#start-quizz"]):not([href="#prev"])'), headerGlob)

if(window.location.hash && !!document.querySelector('.ia-block-list-faqs__content')) {
    if (window.location.hash !== '') {
        let faqToOpen = document.querySelector('.ia-block-list-faqs__content[id="' + (window.location.hash).substring(1) + '"]')
        window.scrollTo(0, 0)
        setTimeout(() => {
            window.scrollTo({
                top:  window.pageYOffset + faqToOpen.getBoundingClientRect().top - document.querySelector('.section-header').offsetHeight - document.querySelector('.section-topbar').offsetHeight - 20,
                behavior: 'smooth'
            });
            faqToOpen.style.height = parseInt(faqToOpen.children[0].clientHeight + faqToOpen.children[1].clientHeight)+'px'
            faqToOpen.classList.add('active')
        }, 200);
    }
}

document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content') 
    )
})

document.querySelectorAll('.ia-block-filter-dropdown').forEach((filterDropdown) => {
    let toggle = filterDropdown.querySelector('.ia-block-filter-dropdown-toggle')
    let target = filterDropdown.querySelector('.ia-block-filter-dropdown-content')

    toggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (target === undefined || target === null) {
            target = toggle.getAttribute('data-target') || toggle.getAttribute('data-toggle')
            if (target === null) {
                target = e.target.nextElementSibling
            }
        }

        if (target !== null) {
            
            factory.$(target).slideToggle()
            e.target.classList.toggle('active')

            // close dropdowns if it's not the one we clicked
            document.querySelectorAll('.ia-block-filter-dropdown').forEach(other => {
                let otherToggle = other.querySelector('.ia-block-filter-dropdown-toggle')
                let otherContent = other.querySelector('.ia-block-filter-dropdown-content')
                if (e.target !== otherToggle) {
                    factory.$(otherContent).slideUp()
                    otherToggle.classList.remove('active')
                }
            })
        }
    })
})

// Swiper sliders initialisation
/*
document.querySelectorAll('.swiper-container:not(.is-fullwidth').forEach((el) => {
    new factory.IASwiper(el, {
        itemPerSlide: 1, // 2 items per view on desktop, 1 on mobile
        autoplay: 2000 // change slide every 2 seconds
    })
})

document.querySelectorAll('.swiper-container.is-fullwidth').forEach((el) => {
    new factory.IASwiper(el, {
        fullwidth: true,
        paginationElement: '.swiper-pagination',
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 4
            }
        }
    })
})
*/

document.querySelectorAll('.ia-block-latest-posts--slider.swiper-container').forEach(el => {
    let swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 40,
        breakpoints: {
            1024: {
                slidesPerView: 2.08,
                spaceBetween: 24
            },
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true
        },
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
        },
    });
});

document.querySelectorAll('.ia-block-bestforyou--slider.swiper-container').forEach(el => {
    let swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 40,
        breakpoints: {
            1024: {
                slidesPerView: 2.08,
                spaceBetween: 24
            },
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true
        },
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
        },
    });
});

if (!!document.querySelector('#newsletterForm')) {
    document.querySelectorAll('#newsletterForm').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '#newsletterForm'
        }).formInside(true)
        form.querySelector('[type="submit"]').addEventListener('click', e => {
            if(form.querySelector('input[name="email"]').value == '' || form.querySelector('input[name="email"]').classList.contains('error')){
                form.querySelector('input[name="email"]').focus()
            }
        })
    })
}
if (!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '.contactForm'
        }).formInside(true)
    })
}

if (!!document.querySelector('.woocommerce-form-login')) {
    document.querySelectorAll('.woocommerce-form-login').forEach(form => {
        new factory.IAForm(form, false).formInside(true)
    })
}

if (!!document.querySelector('form.lost_reset_password')) {
    document.querySelectorAll('form.lost_reset_password').forEach(form => {
        new factory.IAForm(form, false).formInside(true)
    })
}

if (!!document.querySelector('.captcha-option')) {
    document.querySelectorAll('.captcha-option input').forEach(captchaOption => {
        captchaOption.addEventListener('click', (evt) => {
            let that = evt.currentTarget
            let target = document.getElementById(evt.currentTarget.getAttribute('data-target'))

            if (that.checked) {
                target.value = that.value
            } else {
                target.value = ''
            }
            target.dispatchEvent(new Event('change'))
        })
    })
}

if (!!document.querySelector('.form-inside')) {
    document.querySelectorAll('.form-inside').forEach(block => {
        if (block.querySelector('input')?.value.trim() !== '') {
            block.classList.add('is-filled')
        }
    })
}

//TVA 19%
if (!!document.querySelector('.includes_tax .woocommerce-Price-amount')) {
    document.querySelector('.includes_tax .woocommerce-Price-amount').innerHTML = "19%"
}

if(!!document.querySelectorAll('.ia-block-latest-post .load-more')){
    document.querySelectorAll('.ia-block-latest-post .load-more').forEach(newsButton => {
        newsButton.addEventListener('click', (e)=>{
            new factory.IALoadMore().addLoader(newsButton)
        })
    })
}
if(!!document.querySelector('.ia-block-list-faqs')){ 
    const faqDropdown = new IADropdownFaq(document.querySelectorAll('.ia-block-list-faqs__content'))
    document.querySelectorAll('.ia-block-list-faqs__content').forEach((dropdown)=>{
        dropdown.addEventListener('click', function(){
            faqDropdown.openCloseFaq(dropdown)
        })

        window.addEventListener('resize', function(e){
            faqDropdown.resize()
        })
    })

    if(!!document.querySelector('.ia-list-filter-faqs')) {
        document.querySelectorAll('.ia-list-filter-faqs a').forEach(faqFilterButton => {
            faqFilterButton.addEventListener('click', function(e){
                e.preventDefault()
                document.querySelectorAll('.ia-list-filter-faqs a').forEach(element => element.classList.remove('active'));
                e.target.classList.add('active')
                filterFaqs(e.target, document.querySelectorAll('.ia-block-list-faqs__content'))
                faqDropdown.resize()
            })
        });
    }
}

if (!!document.querySelector('.ia-block-product-quantity__input')) {
    document.querySelectorAll('.ia-block-product-quantity__input').forEach(block => {
        let input = block.querySelector('input[type="number"]')
        let decrementBtn = block.querySelector('.ia-block-product-quantity__button--decrement')
        let incrementBtn = block.querySelector('.ia-block-product-quantity__button--increment')

        incrementBtn.addEventListener('click', (e) => {
            e.preventDefault()
            input.stepUp()
        })

        decrementBtn.addEventListener('click', (e) => {
            e.preventDefault()
            input.stepDown()
        })
    })
}

if (!!document.querySelector('.variations #pa_content[name="attribute_pa_content"]')) {
    // on radio button change(click)
    document.querySelectorAll('.iawp-variation-radios input').forEach((el) => {
        el.addEventListener('click', (e) => {
            console.log('coucou click', e)
            const radio = e.currentTarget
            const radioName = radio.getAttribute('name')
            const radioValue = radio.value

            console.log({radioName, radioValue})

            console.log(document.querySelector('select[name="' + radioName + '"]'))

            document.querySelector('select[name="' + radioName + '"]').value = radioValue
            document.querySelector('select[name="' + radioName + '"]').dispatchEvent(new Event('change', {bubbles: true}))
        })
    });

    document.querySelector('.variations #pa_content[name="attribute_pa_content"]').addEventListener('change', (e) => {
        let contentVariation = e.currentTarget.value
        let perLitreVariations = document.querySelectorAll('.ia-block-product-content.per_litre')
        let price = document.querySelector('.entry-summary .price')
        
        perLitreVariations.forEach(variation => {
            if (variation.classList.contains('per_litre_' + contentVariation.replace('-',''))) {
                variation.style.display = 'block'
            } else {
                variation.style.display = 'none'
            }
        })

        let variationsData = e.currentTarget.closest('.variations_form.cart').getAttribute('data-product_variations')
        variationsData = JSON.parse(variationsData)
        let selectedVariation = variationsData.filter(o => {
            return o.attributes.attribute_pa_content === contentVariation
        })[0]

        console.log(variationsData, selectedVariation)

        let locale = document.querySelector('html').getAttribute('lang') === 'de' ? 'de-DE' : 'en-GB'

        let EUR = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: 'EUR'
        })

        if (selectedVariation.display_price !== selectedVariation.display_regular_price) {
            //product discount

            let discountPercentage = Math.round((1-(selectedVariation.display_price/selectedVariation.display_regular_price))*100)

            let discount = locale === 'de-DE' ? discountPercentage + '% Sparen' : 'Save ' + discountPercentage + '%'

            price.innerHTML = '<ins class="new-price">' + EUR.format(selectedVariation.display_price) + '</ins><span class="percentage-off">' + discount + '</span><del class="old-price">' + EUR.format(selectedVariation.display_regular_price) + '</del>';
        } else {
            price.innerHTML = EUR.format(selectedVariation.display_price);
        }

        setTimeout(() => {
            let variationPrice = document.querySelector('.entry-summary .woocommerce-variation-price .price')
            variationPrice.style.display = 'none'
            //price.innerHTML = variationPrice.textContent
        }, 200)

    })

}

if (!!document.querySelector('.ia-block-product-finder-submission')) {
    initProductFinderSubmissionForm()
}

// if (!!document.querySelector('.area-search')) {
//     document.querySelector('.area-search .ia-block-searchbar__toggle button').addEventListener('click', function(e) {
//         const searchArea = e.target.closest('.area-search');
//         const isCollapsed = !searchArea.classList.contains('is-open');
//         const iconToAdd = isCollapsed ? e.currentTarget.querySelector('i.ia-icon').getAttribute('data-icon-expanded') : e.currentTarget.querySelector('i.ia-icon').getAttribute('data-icon-collapsed');
//         const iconToRemove = !isCollapsed ? e.currentTarget.querySelector('i.ia-icon').getAttribute('data-icon-expanded') : e.currentTarget.querySelector('i.ia-icon').getAttribute('data-icon-collapsed');
//         e.currentTarget.querySelector('i.ia-icon').classList.remove(iconToRemove);
//         e.currentTarget.querySelector('i.ia-icon').classList.add(iconToAdd);
//         searchArea.classList.toggle('is-open');
//     })
// }

if (!!document.querySelector('.wp-block-column')) {
    document.querySelectorAll('.wp-block-column').forEach(column => {
        const hasGradientShapeClass = Array.from(column.classList).some(c => c.startsWith('has-shape-'))
        if (hasGradientShapeClass) {
            if(!!column.querySelector('.wp-block-spacer')) {
                const spacerHeight = column.querySelector('.wp-block-spacer').style.height
                column.querySelector('.wp-block-spacer').style.height = 0
                column.style.marginTop = spacerHeight
            }
        }
    });
}

if (!!document.querySelector('.input-range')) {
    new priceRangeSlider()
}

if (!!document.querySelector('.woocommerce-product-gallery__wrapper')) {
    
    document.querySelectorAll('.woocommerce-product-gallery__wrapper').forEach(block => {
        let links = block.querySelectorAll('.woocommerce-product-gallery__image a')
        links.forEach(link => {
            link.setAttribute('data-fancybox', 'gallery')
        })
        Fancybox.bind('[data-fancybox="gallery"]', {});
          
    })
}

// Manage topbar z-index on scroll
(function (){
    let header = document.querySelector('.section-header')
    let topbar = document.querySelector('.section-topbar')

    var x = window.matchMedia("(max-width: 1024px)");

    function changeZIndexMQ(x) {
        return;
        document.addEventListener('scroll', (event) => {
            if (x.matches) {
                // if (topbar.offsetTop > window.scrollY) {
                    // if (!!header.querySelector('.ia-block-navigation__content.is-open')) 
                    // topbar.style.zIndex = 1001;
                // } else {
                    topbar.style.zIndex = 1000;
                // }
            } else {
                topbar.style.zIndex = 1001;
            }
        });
    }

    changeZIndexMQ(x);

    x.addEventListener('change', function() {
        changeZIndexMQ(x);
    });
    
})();

factory.$('.comment-form').find(factory.$(".comment-form-comment, .comment-form-author, .comment-form-email, .comment-form-url")).each(function () {
    var $wrapper = factory.$(this);
    var $input = $wrapper.find("input,textarea,select");

    $input
        .on("focusin", function () {
        if (!$input.val()) {
            $wrapper.removeClass("is-filled");
        }

        $wrapper.addClass("is-focus");
        })
        .on("focusout", function () {
        if (!$input.val()) {
            $wrapper.removeClass("is-focus");
        } else {
            $wrapper.addClass("is-filled");
            $wrapper.removeClass("is-focus");
        } if ($input.val() == '') {
            $wrapper.removeClass("is-filled");
        }
        });
});


// Salesforce
factory.$('.ia-block-form.is-salesforce .form-inside').each(function () {
    var $wrapper = factory.$(this);
    var $input = $wrapper.find("input,textarea,select");

    $input
        .on("focusin", function () {
        if (!$input.val()) {
            $wrapper.removeClass("is-filled");
        }

        $wrapper.addClass("is-focus");
        })
        .on("focusout", function () {
        if (!$input.val()) {
            $wrapper.removeClass("is-focus");
        } else {
            $wrapper.addClass("is-filled");
            $wrapper.removeClass("is-focus");
        } if ($input.val() == '') {
            $wrapper.removeClass("is-filled");
        }
        });
});

$('.ia-block-form.is-salesforce form').validate({
    
})


// FOOTER MENU MOBILE
if (factory.$('.footer__menus').length) {
    function footerMenus (mq) {
        if (mq.matches) {
            factory.$('.footer__menus nav').hide();
            factory.$('.footer__menus h2').on('click', function(){
                let nav = factory.$(this).next('nav')
                console.log(nav)
                nav.slideToggle()
            })
        } else {
            factory.$('.footer__menus h2').off();
            factory.$('.footer__menus nav').show();
        }
    }

    let footerMenusMQ = window.matchMedia("(max-width: 640px)")
    footerMenus(footerMenusMQ)
    footerMenusMQ.addEventListener('change', () => footerMenus(footerMenusMQ))
}

document.querySelectorAll('.ia-block-sticky-blog-posts--slider.swiper-container').forEach(el => {
    let swiperInstance = new Swiper(el, {
        slidesPerView: 1.17,
        spaceBetween: 0,
        loop: true,
        breakpoints: {
            1024: {
                slidesPerView: 2.17,
                spaceBetween: 0
            },
        },
        navigation: {
            nextEl: '.ia-block-sticky-blog-posts .swiper-button-next',
            prevEl: '.ia-block-sticky-blog-posts .swiper-button-prev',
        },
    });
});

(function() {
    const tabletPortraitBreakpoint = window.matchMedia('(min-width: 769px)');
    let featuredShopCategoriesSwiper;

    const tabletPortraitBreakpointChecker = function() {
        if (tabletPortraitBreakpoint.matches === true) {
            if (featuredShopCategoriesSwiper !== undefined) {
                featuredShopCategoriesSwiper.destroy(true, true);
            }
            return;
        } else if (tabletPortraitBreakpoint.matches === false) {
            return enableFeaturedShopCategoriesSwiper();
        }
    }
    
    const enableFeaturedShopCategoriesSwiper = function() {
        featuredShopCategoriesSwiper = new Swiper('.ia-block-shop-featured-categories-wrapper.swiper-container', {
            slidesPerView: 1,
            spaceBetween: 16,
            scrollbar: {
                el: '.ia-block-shop-featured-categories-wrapper .swiper-scrollbar',
                draggable: true
            }
        })
    }

    tabletPortraitBreakpoint.addListener(tabletPortraitBreakpointChecker)
    tabletPortraitBreakpointChecker()
})();
let intervalCartTime = 0;
const expand = {
    trads : {
        en : 'See more product info',
        de : 'Weitere Produktinformation anzeigen'
    },
    arrayExclude : ['wc-block-components-product-details__basis','wc-block-components-product-details__for-whom', 'wc-block-components-product-details__f-r-wen', 'wc-block-components-product-details__product-type', 'wc-block-components-product-details__produktart'],
    items : []
}
let cart = setInterval(() => {
    intervalCartTime = intervalCartTime + 50
    if(!!document.querySelector('.wc-block-components-product-details')){
        clearInterval(cart)
        document.querySelectorAll('.wp-block-woocommerce-cart').forEach(cart=> {
            cart.querySelectorAll('.wc-block-cart-item__product').forEach(product => {
                expand.items = []
                const productDetailArray = [...product.querySelector('.wc-block-components-product-details').children]
                productDetailArray.forEach(detail => {
                    if([...detail.classList].some(item => expand.arrayExclude.includes(item))) {
                        expand.items.push(detail.outerHTML)
                        detail.remove()
                    }
                })
                const blockExpand = document.createElement('div')
                blockExpand.classList.add('ia-block-expand')
                const blockExpandTitle = document.createElement('button')
                blockExpandTitle.classList.add('ia-block-expand__title')
                blockExpandTitle.textContent = expand.trads[document.querySelector('html').lang]
                const blockExpandContent = document.createElement('ul')
                blockExpandContent.classList.add('ia-block-expand__content')
                blockExpandContent.innerHTML = expand.items.join("")
                blockExpand.append(blockExpandTitle,blockExpandContent)
                blockExpandTitle.addEventListener('click', e => {
                    e.target.classList.toggle('active')
                })
                product.querySelector('.wc-block-cart-item__wrap').append(blockExpand)
            })
        })
        
    }else if(intervalCartTime >= 5000){
        clearInterval(cart)
    }
}, 200);



if(!!document.querySelector('.woocommerce-products-compare-compare-button')){
    document.querySelectorAll('.woocommerce-products-compare-compare-button input').forEach(inputCompare => {
        inputCompare.addEventListener('change', compareButton=>{
            compareButton.stopImmediatePropagation()
            setTimeout(() => {
                compareMessage(inputCompare.checked);  
            }, 300);
        })
    })
}

if (!!document.querySelector('body.single-product') && document.querySelector('.woocommerce-products-compare-compare-button')) {

    let compare_btn = document.querySelector('.woocommerce-products-compare-compare-button')
    let qty = document.querySelector('.ia-block-product-quantity')
    qty.appendChild(compare_btn)

}
// Compare message
function compareMessage(input){
    const formData = new FormData();
    formData.append("action", 'compareMessageAjax');
    formData.append('addItem', input)

    const xhr = new XMLHttpRequest();
    xhr.open("POST", ajaxurl, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
            let response = JSON.parse(xhr.response)
            if(!!document.querySelector('.woocommerce-notices-wrapper')) {
                document.querySelector('.woocommerce-notices-wrapper').innerHTML = response
            }else{
                const wrapper = document.createElement('div')
                wrapper.classList.add('woocommerce-notices-wrapper')
                wrapper.innerHTML = response

                if(!!document.querySelector('.site-main')) {
                    document.querySelector('.site-main').prepend(wrapper) //shop
                } else {
                    document.querySelector('.section-default-inner').prepend(wrapper) //category pages
                }
            }
        }
    };
    xhr.send(formData);
}